import { useCallback, useState } from 'react';
import TextInputWithButton, {
  TextInputWithButtonProps,
} from '../TextInputWithButton/TextInputWithButton';

const isValidUrl = (url: string) =>
  /^(https?|ftp):\/\/([a-zA-Z0-9._-]+)(:\d+)?(\/[^\s]*)?$/i.test(url);

type Response = {
  code: number;
  text: string;
};

type Props = Omit<TextInputWithButtonProps, 'onButtonClick' | 'buttonText'> & {
  onResponse: (response: Response) => void;
  onFetchError: (error: Error) => void;
};

const UrlInput = ({
  onResponse,
  onFetchError,
  value,
  buttonProps,
  ...props
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const onFetch = useCallback(async () => {
    if (value) {
      if (!isValidUrl(value)) {
        onFetchError(new Error('Invalid URL'));
        return;
      }
      try {
        setIsLoading(true);
        const response = await fetch(value);
        const status = response.status;
        const text = await response.text();
        onResponse({ code: status, text });
      } catch (error) {
        onFetchError(new Error('Error fetching URL'));
      } finally {
        setIsLoading(false);
      }
    }
  }, [onResponse, onFetchError, value]);
  return (
    <TextInputWithButton
      {...props}
      onButtonClick={onFetch}
      buttonText="Fetch"
      loading={isLoading}
      value={value}
      buttonProps={{
        disabled: isLoading || value?.trim() === '',
        ...buttonProps,
      }}
    />
  );
};

export default UrlInput;
